(function ($) {
    /**
     * Check if the given date is valid. Needs to be checked on inital call and
     * on submit
     *
     * @param dateValue
     * @returns {boolean}
     */
    function checkDate(dateValue) {
        if (dateValue) {
            let [day, month, year] = dateValue.split('.'),
                date = new Date(year, month - 1, day);

            if (date instanceof Date && !isNaN(date)) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    /**
     * Set cookie
     *
     * @param key
     * @param value
     */
    function setCookie(key, value) {
        document.cookie = key + '=' + value + ';path=/';
        location.reload();
    }

    /**
     * Method to get the value of a cookie
     * From https://stackoverflow.com/questions/10730362/get-cookie-by-name
     *
     * @param name
     * @returns {*}
     */
    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) {
            return match[2];
        } else {
            return '';
        }
    }

    /**
     * Delete cookie
     *
     * @param key
     */
    function deleteCookie(key) {
        var d = new Date;
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * -1);

        document.cookie = key + '=;path=/;expires=' + d.toGMTString();
        location.reload();
    }

    const cookieKey = 'timeTraveler',
        $dateValue = $('[data-timetraveler-value]');

    let currentCookieValue = getCookie(cookieKey);

    // Check the correct cookie first
    if (currentCookieValue !== '') {
        if (checkDate(currentCookieValue)) {
            $dateValue.val(currentCookieValue);
        } else {
            deleteCookie(cookieKey);
        }
    }

    // Submit override for deleting / setting the cookie
    $('[data-timetraveler]').submit(function (event) {
        event.preventDefault();

        let dateValue = $dateValue.val();

        // Delete cookie if value is empty; otherwise check if a correct date is entered
        // and set the cookie then
        if (dateValue === '') {
            deleteCookie(cookieKey);
        } else if (checkDate(dateValue)) {
            setCookie(cookieKey, dateValue);
        }

        return false;
    });
})(jQuery);
